module.exports = __webpack_public_path__ + "static/media/bulb_once.9825b8e6.gif";